"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATCGroup = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const atc_group_header_1 = __importDefault(require("./atc.group.header"));
const atc_group_body_1 = __importDefault(require("./atc.group.body"));
const atc_group_style_1 = __importDefault(require("./atc.group.style"));
class ATCGroup extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, children, avatarSrc, header, headerOnClick, loading, disabled } = this.props;
            return (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.root, "aria-busy": loading, "data-cy": "atomic-atc-group" }, { children: [jsx_runtime_1.jsx(atc_group_header_1.default, { onClick: headerOnClick, avatarSrc: avatarSrc, text: header, loading: loading, disabled: disabled }, void 0),
                    jsx_runtime_1.jsx(atc_group_body_1.default, Object.assign({ loading: loading }, { children: children }), void 0)] }), void 0));
        };
    }
}
exports.ATCGroup = ATCGroup;
ATCGroup.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.node,
    avatarSrc: prop_types_1.default.string,
    header: prop_types_1.default.string.isRequired,
    headerOnClick: prop_types_1.default.func.isRequired,
    disabled: prop_types_1.default.bool,
    loading: prop_types_1.default.bool
};
ATCGroup.defaultProps = {
    children: null,
    avatarSrc: null,
    disabled: false,
    loading: false
};
exports.default = react_jss_1.default(atc_group_style_1.default)(ATCGroup);
//# sourceMappingURL=atc.group.js.map